import React from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { useUser } from '../../hooks/useUser'
import { portalBasePath } from '../../utils/portalPath'

const VALID_TOOLS = ['pdp-audit', 'proposal', 'proposals', 'prep-pack']

// Forwards a logged-in RMN user to their brand's portal (/portal/:slug/*)
// without the caller needing to know the brand slug — the slug-agnostic
// /rmn-tools/:tool links. The legacy tool names redirect on to the pages
// that replaced them.
export default function RmnEntryRedirect(): JSX.Element {
  const { user } = useUser()
  const { tool } = useParams()

  const brands: any[] = (user as any)?.brand || []
  // Direct members of an RMN brand only — supplier-brand users don't get
  // portal access (matches rmnControl/RmnAuthGuard). Never fall back to a
  // non-RMN brand slug: the public /rmn/:slug lookup requires rmn:true and
  // would dead-end the user on /404 instead of the message below.
  const rmnBrand = brands.find((b) => b?.rmn && b?.slug)

  if (!rmnBrand?.slug) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[50vh] text-center px-4">
        <h1 className="text-xl font-semibold mb-2">No RMN portal available</h1>
        <p className="text-text-2">
          Your account is not linked to a retail media network brand yet.
          Please contact your account manager.
        </p>
      </div>
    )
  }

  const target = tool && VALID_TOOLS.includes(tool) ? tool : 'pdp-audit'
  return <Navigate to={`${portalBasePath(rmnBrand.slug)}/${target}`} replace />
}
